import axios, { AxiosError, AxiosInstance } from 'axios';
import { ENV_VARIABLES } from '../common/constants';
import { useConnectivityStore } from '../stores/useConnectivityStore';
import {
  AdminAssetsApi,
  AdminErrorCodesApi,
  AdminFeatureFlagsApi,
  AdminModuleRunsApi,
  AdminModulesApi,
  AdminNotificationLogApi,
  AdminNotificationSettingsApi,
  AdminNotificationsApi,
  AdminTranslationsApi,
  AdminUsersApi,
  AdminVideoJobsApi,
  UserAuthApi,
  UsersApi,
  QualicamApi,
  AdminRoleApi,
  TranslationsApi,
} from 'src/generated/rest-api/types';

export class RestAPI {
  httpClient: AxiosInstance;
  apis: {
    adminRole: AdminRoleApi;
    adminUsers: AdminUsersApi;
    assets: AdminAssetsApi;
    auth: UserAuthApi;
    errorCodes: AdminErrorCodesApi;
    featureFlags: AdminFeatureFlagsApi;
    moduleRuns: AdminModuleRunsApi;
    modules: AdminModulesApi;
    notificationLog: AdminNotificationLogApi;
    notificationSettings: AdminNotificationSettingsApi;
    notifications: AdminNotificationsApi;
    qualicam: QualicamApi;
    translations: TranslationsApi;
    translationsAdmin: AdminTranslationsApi;
    users: UsersApi;
    videoJobs: AdminVideoJobsApi;
  };

  constructor() {
    const basePath = ENV_VARIABLES.REST_API_URL;
    this.httpClient = axios.create();

    // Only a true network-level failure (no error.response) means unreachable.
    this.httpClient.interceptors.response.use(
      (response) => {
        useConnectivityStore.getState().setReachable();
        return response;
      },
      (error: AxiosError) => {
        if (!error.response) {
          useConnectivityStore.getState().setUnreachable();
        }
        return Promise.reject(error);
      },
    );

    this.apis = {
      adminRole: new AdminRoleApi(undefined, basePath, this.httpClient),
      adminUsers: new AdminUsersApi(undefined, basePath, this.httpClient),
      assets: new AdminAssetsApi(undefined, basePath, this.httpClient),
      auth: new UserAuthApi(undefined, basePath, this.httpClient),
      errorCodes: new AdminErrorCodesApi(undefined, basePath, this.httpClient),
      featureFlags: new AdminFeatureFlagsApi(
        undefined,
        basePath,
        this.httpClient,
      ),
      moduleRuns: new AdminModuleRunsApi(undefined, basePath, this.httpClient),
      modules: new AdminModulesApi(undefined, basePath, this.httpClient),
      notificationLog: new AdminNotificationLogApi(
        undefined,
        basePath,
        this.httpClient,
      ),
      notifications: new AdminNotificationsApi(
        undefined,
        basePath,
        this.httpClient,
      ),
      notificationSettings: new AdminNotificationSettingsApi(
        undefined,
        basePath,
        this.httpClient,
      ),
      qualicam: new QualicamApi(undefined, basePath, this.httpClient),
      translations: new TranslationsApi(undefined, basePath, this.httpClient),
      translationsAdmin: new AdminTranslationsApi(
        undefined,
        basePath,
        this.httpClient,
      ),
      users: new UsersApi(undefined, basePath, this.httpClient),
      videoJobs: new AdminVideoJobsApi(undefined, basePath, this.httpClient),
    };
  }
}

export const RestAPIInstance = new RestAPI();
